export const SETTINGS_QUERY_KEY = 'settings';
